export default class ConsultationAllowedType {
  constructor(id, enabled, provider, procedure) {
    this.id = id;
    this.enabled = enabled;
    this.provider = provider;
    this.procedure = procedure;
  }
}